import { useState } from "react"
import { useParams } from "react-router-dom"
import {faArrowDown, faArrowUp} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
export const TaskCheckbox = ({tasks, selectedTasks, setSelectedTasks}) => {
    const [q, setQ] = useState("")
    const [privateSelected, setPrivateSelected] = useState([...selectedTasks])
    const [openTask, setOpenTask] = useState(false)
    const {groupId} = useParams()
    const { ids, entities } = tasks
    const filteredIds =  (q || groupId!=="0")? [...ids].filter(taskId =>{
      const task =  entities[taskId]
      return ((task.title.toLowerCase().indexOf(q.toLowerCase()) >-1)||(task.groupname.toLowerCase().indexOf(q.toLowerCase()) > -1 )) && (groupId==='0' || task.group === groupId )

    }) : [...ids]


    const selectTask = (e) => {
        if(e.target.checked){
          setPrivateSelected([...privateSelected, e.target.value])
        }else{
          setPrivateSelected(privateSelected.filter(task=>task !== e.target.value))
        }
    }

    const clearSelected = () => {
      setPrivateSelected([])
      setSelectedTasks([])
      setOpenTask(false)
      setQ("")
    }

    const showSelected = () => {  
      setSelectedTasks(privateSelected)
      setOpenTask(false)
    }

    const openClosePanel = () => {
      if(openTask){
        setOpenTask(false)
      }else{
        setOpenTask(true)
      }
    }
    const extLabel = openTask  ? <>סגור<FontAwesomeIcon icon={faArrowUp} /></> : <> לחץ לעדכון <FontAwesomeIcon icon={faArrowDown} /></>
    let label =  privateSelected.length > 0 ? <> נבחרו {privateSelected.length} משימות {extLabel}  </>:<>בחר משימות  {extLabel}  </>

  return (
    <div className="task-cb-wrapper">
 <div className=" flex gap-2 my-2 justify-between items-center">
        <div className="flex gap-2 items-center">
 <button className="bg-white rounded p-2 w-80" onClick={openClosePanel}>{label} </button>
      <button
      disabled={!privateSelected.length}
       className={` text-white rounded p-2 w-20 text-center ${privateSelected.length? 'bg-blue-500':'bg-gray-500'}`} onClick={showSelected}> הצג </button>
        </div>
     <div className="flex gap-2 items-center">

       {openTask &&      <input value={q} className="rounded p-2" type="text" placeholder="חיפוש לפי משימה או לפי קבוצה" onChange={(e)=>setQ(e.target.value)} />}

      <button className="bg-white rounded p-2 justify-self-end" onClick={clearSelected}>נקה הכל</button>
  </div>
      </div>


        {openTask && <div className="task-cb">
        <div className="friend-list">
         {filteredIds.map(taskId=>{
           return <div key={taskId}>  <input value={taskId} checked={privateSelected.indexOf(taskId) > -1}   type="checkbox" onChange={selectTask}  /> {entities[taskId].title} {entities[taskId].groupname}   </div>
        })} 
        </div>
        </div>}
    </div>
  )
}
